import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { ToolDeleteStrategy } from '../../../../projectDetails.models';

export const RenderRelatedAnnotationsCount = ({ strategy, count }: { strategy: ToolDeleteStrategy; count: number }): ReactElement => {
  const { t } = useTranslator();

  switch (strategy) {
    case ToolDeleteStrategy.Leave:
      return <span> {t('activity_description_common.related_annotations_left', { count })}</span>;
    case ToolDeleteStrategy.MoveToDraft:
      return <span> {t('activity_description_common.related_annotations_draft', { count })}</span>;
    case ToolDeleteStrategy.MoveToReview:
      return <span> {t('activity_description_common.related_annotations_to_review', { count })}</span>;
    case ToolDeleteStrategy.Discard:
      return <span> {t('activity_description_common.related_annotations_discarded', { count })}</span>;
    case ToolDeleteStrategy.None:
    default:
      return <span />;
  }
};
